import { FormFieldInputs } from '../../components/input/Input';

export interface CheckoutFormFields {
    email: string;
}

export const checkoutFormFieldInputs: FormFieldInputs = {
    email: {
        name: 'email',
        label: 'Email',
        type: 'email',
        rules: {
            required: 'Email is required',
            maxLength: {
                value: 253,
                message: 'Cannot be more than 253 characters',
            },
            pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: 'Please enter a valid email address',
            },
        },
    },
};

export const checkoutFormInitialValues: CheckoutFormFields = {
    email: '',
};
